import { DynamicObject } from '../utils/commonTypes';

class Store {
  cache: DynamicObject = {};
  set(key: string, value: DynamicObject | string | number) {
    this.cache[key] = value;
  }
  get(key: string) {
    return this.cache[key];
  }
}
const SimpleStore = new Store();
export default SimpleStore;
